<div class="images">
  <img
    class="channel-icon"
    [src]="'assets/img/site_icon/v2/' + task.site.type_name + '.png'"
    [matTooltip]="accountTypeTranslation" />

  <app-avatar [isCompany]="true" class="avatar"></app-avatar>
</div>

<!-- site name -->
<div class="alc-ellipsis" [matTooltip]="task.site.name" appMatTooltipShowIfTruncated>
  {{ task.site.name }}
</div>

<!-- private/public/hidden + channel -->
<div class="alc-ellipsis" [matTooltip]="channelName" appMatTooltipShowIfTruncated>
  <span *ngIf="task.message.is_private; else public" translate="inbox/message/infos/private"></span>
  <ng-template #public>
    <strong
      ><span
        *ngIf="!task.message.is_private && !task.message.details.is_hidden; else hidden"
        translate="inbox/message/infos/public"></span
    ></strong>
  </ng-template>
  <ng-template #hidden>
    <span
      *ngIf="!task.message.is_private && task.message.details.is_hidden"
      translate="inbox/message/infos/hidden"></span>
  </ng-template>
  <span *ngIf="task.message.detailed_task_type"> - {{ channelName }}</span>
</div>

<!-- team -->
<div class="top10 with-icon alc-ellipsis" [matTooltip]="team.name" appMatTooltipShowIfTruncated>
  <mat-icon>people</mat-icon>
  <span>{{ team.name }}</span>
</div>

<!-- relative date -->
<div class="top10 alc-ellipsis" [class.blue]="task.message.external_url">
  <ng-container *ngIf="task.message.external_url; else noUrl">
    <a href="{{ task.message.external_url }}" target="_blank" class="with-icon" [matTooltip]="fullDateTime">
      <ng-container [ngTemplateOutlet]="dateTime"></ng-container>
    </a>
  </ng-container>
  <ng-template #noUrl>
    <span class="with-icon" [matTooltip]="fullDateTime">
      <ng-container [ngTemplateOutlet]="dateTime"></ng-container>
    </span>
  </ng-template>
</div>

<ng-template #dateTime>
  <mat-icon>schedule</mat-icon>
  <span><app-relative-date-time [date]="task.message.created_time"></app-relative-date-time></span>
</ng-template>
